import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.access');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-access',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.access/view.scss */
:host {
  display: block;
  min-height: 100%;
}`],
})
export class PageAccessComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public data: any = {
        id: 'admin',
        password: ''
    };

    public loading: boolean = false;

    public async ngOnInit() {
        await this.service.init();
        const params = new URLSearchParams(window.location.search);
        if (params.get('logout') === '1') {
            const { code } = await wiz.call("logout");
            if (code !== 200) this.clearSessionCookie();
            window.location.replace("/access");
            return;
        }
        const { code, data } = await wiz.call("status");
        if (code === 200 && data.authenticated) {
            window.location.replace("/dashboard");
            return;
        }
        await this.service.render();
    }

    public async alert(message: string, status: string = 'error') {
        return await this.service.modal.show({
            title: "로그인 확인",
            message: message,
            cancel: false,
            actionBtn: status,
            action: '확인',
            status: status
        });
    }

    public async login() {
        const user = JSON.parse(JSON.stringify(this.data));
        if (!user.id) {
            await this.alert("아이디를 입력해주세요.");
            return;
        }
        if (!user.password) {
            await this.alert("비밀번호를 입력해주세요.");
            return;
        }

        this.loading = true;
        await this.service.render();

        const { code, data } = await wiz.call("login", user);

        this.loading = false;
        if (code === 200) {
            window.location.replace("/dashboard");
            return;
        }

        await this.alert(data.message || "로그인에 실패했습니다.", 'error');
        await this.service.render();
    }

    public clearSessionCookie() {
        document.cookie = "session=; Max-Age=0; path=/";
        document.cookie = "session=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/";
    }
}

export default PageAccessComponent;